import { Flex, Text } from '@mantine/core';
import ReactCountryFlag from 'react-country-flag';
import { GetPersonTaxInformationRes } from '@dealstack/shared/lib/generated';
import { getCountryNameByCode } from '@dealstack/shared/lib/countries/countriesData';
import { useTranslationCommonUi } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { makeComplexDataTestId, TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';
import { DetailsTileStyles } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/DetailsTile.styles.tsx';
import { InvestorDetailsRow } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/InvestorDetailsRow/InvestorDetailsRow.tsx';

interface Props {
	taxRecord: GetPersonTaxInformationRes;
}

export const TaxRecordItem = ({ taxRecord }: Props) => {
	const tCommonUi = useTranslationCommonUi();

	const countryName = getCountryNameByCode(taxRecord.countryCode) || taxRecord.countryCode;
	const tinLabel = taxRecord.authority || tCommonUi('tin');

	return (
		<DetailsTileStyles
			data-testid={makeComplexDataTestId(
				TEST_ELEMENT_IDS.MIP_MANAGE_INVESTORS_DETAILS_TAX_RECORD,
				taxRecord.id
			)}
		>
			<Flex gap="0.25rem" align="center" maw="100%">
				<ReactCountryFlag
					countryCode={taxRecord.countryCode}
					svg
					style={{ width: '1em', height: '1em', flexShrink: 0 }}
					title={taxRecord.countryCode}
				/>

				<Text fz={14} fw={600} c="dark.8" truncate>
					{countryName}
				</Text>
			</Flex>

			{!!taxRecord.number && (
				<InvestorDetailsRow
					label={tinLabel}
					value={taxRecord.number}
					copyValue={taxRecord.number}
					showValueTooltip
					padding="0"
					dataTestId={makeComplexDataTestId(
						TEST_ELEMENT_IDS.MIP_MANAGE_INVESTORS_DETAILS_TAX_TIN,
						taxRecord.id
					)}
				/>
			)}
		</DetailsTileStyles>
	);
};
